/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-console */
/* eslint-disable max-len */
import Close from '@mui/icons-material/Close';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { Badge, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, IconButton, Menu, Modal, Stack, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { memo, useCallback, useContext, useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { CgProfile } from 'react-icons/cg';
import { FiClock, FiMinimize, FiSend } from 'react-icons/fi';
import { GiHamburgerMenu } from 'react-icons/gi';
import { MdFullscreen } from 'react-icons/md';
import { RiMenuFoldFill, RiMenuUnfoldFill } from 'react-icons/ri';
import { TbLogout } from 'react-icons/tb';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { LoginContext } from '../../App';
import '../../UiComponents/SideNav/styles.css';
import '../../UiStyles/Circles/styles.css';
import DialogPopup from '../../components/Common/DeletePopUp/DeletePopup';
import { useChat } from '../../components/Common/GlobalChat/Components/ChatContext';
import RemindPopover from '../../components/Common/ReminderCard/RemindPopup';
import EmployeeListSlider from '../../containers/EmployeeMangement/components/EmployeeInviteSlider';
import ProfileSettingsNav from '../../containers/ProfileSettings';
import { HamburgerContext, LanguageContext } from '../../libs/Context';
import useStoreEmpty from '../../libs/CustomHooks/useStoreEmpty';
import { resetMediaKitData, setLoggingOutForMedia } from '../../redux/MediakitRedux';
import { MarkingTab, certifciteTab } from '../../redux/NetworkRedux';
import { getDealData, getUserSession, getNotification } from '../../redux/UserSessionSlice';
import InLinkLogo from '../InlinkLogo';
import BusinessSideNav from '../SideNav/components/BusinessSideNav';
import ReminderSlider from '../SideNav/components/Reminder/Reminder';
import './styles.css';
// import { Image } from '../../libs/CustomHooks/Image';
import Loading from '../../components/Common/Loaders/FullWidthLoader/Loading';
import useMessageHook from '../../containers/CollaborationRevised/customHooks/useMessageHook';
import { userFullName } from '../../libs/HelperContent';
import { getNotifications, updateNotifications } from '../../containers/actions/notifications';
import useLogout from '../../components/Hooks/useLogout';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { logoutUser } from '../../containers/actions/admin_actions';

const style = {
	position     : 'absolute',
	top          : 'var(--percent50)',
	left         : 'var(--percent50)',
	transform    : 'translate(-50%, -50%)',
	width        : '20rem',
	bgcolor      : 'background.paper',
	boxShadow    : 24,
	textAlign    : 'center',
	borderRadius : 'var(--pixel12)'
};

const Data = [ { id: 'en', label: 'English' }, { id: 'hi', label: 'Hindi - हिन्दी' }, { id: 'pn', label: 'Punjabi - ਪੰਜਾਬੀ' }, { id: 'te', label: 'Telugu - తెలుగు' }, { id: 'mr', label: 'Marathi - मराठी' }, { id: 'kn', label: 'Kanada - ಕನ್ನಡ' }, { id: 'bn', label: 'Bengali - বাংলা' }, { id: 'ml', label: 'Malayalam - മലയാളം' } ];

const CommonHeader = (props) =>
{
	const { language } = useContext(LanguageContext);
	// const { userOnlineOfflineStatusRef} = useContext(firebaseStorage);
	const emptyReduxState = useStoreEmpty();
	const location = useLocation();
	const activePath = location.pathname.split('/')[1];
	const [ langOpen, setLangOpen ] = useState(false);
	const { socket } = useContext(LoginContext);
	const { hamBurgerShow, setHamBurgerShow, showSideNavIcons, maximizeScreen, setMaximizeScreen, setShowSideNavIcons } = useContext(HamburgerContext);
	const navigate = useNavigate();
	const userData = useSelector((state:any) => state?.mysession?.session);
	const nc:any = useSelector((state:any) => state?.mysession?.notificationCount);
	const [ anchorEl, setAnchorEl ] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const dispatch = useDispatch();
	const myMediaKitUploadFile = useSelector((state:any) => state.mymediakit.uploadFile);
	const { setCatTab } = useContext(LoginContext);
	const [ profileSettings, setProfileSettings ] = useState(false);
	const overflowStyle = hamBurgerShow ? 'hidden' : 'unset';
	const [ logout, setLogout ] = useState(false);
	const [ logoutFromAllDevices, setLogoutFromAllDevices ] = useState(false);
	const [ openSlider, setOpenSlider ] = useState<boolean>(false);
	const [ checkScreenSize, setCheckScreenSize ] = useState<any>(window.innerWidth);
	const [ maximize, setMaximize ] = useState(false);
	const [ showReminder, setShowReminder ] = useState<boolean>(false);
	const [ anchorElPop, setAnchorElPop ] = useState<boolean>(false);
	const [ clickCount, setClickCount ] = useState(0);
	const [ loading, setLoading ] = useState<boolean>(false);
	const handleLogout = useLogout();
	const { handleLogoutForCollaboration } = useMessageHook();
	const [ imageError, setImageError ] = useState(false);
	const imagePath = useMemo(() =>
	{
		return `${process.env.REACT_APP_S3_GET_URL}/profile/${userData?.userId}_profile.jpeg?t=${Date.now()}`;
	}, [ userData?.profileImage ]);
	const handleClose = () =>
	{
		setAnchorEl(null);
	};

	const handleOpenPop = (event) =>
	{
		if (anchorElPop === event.currentTarget)
		{
			setAnchorElPop(false);
		}
		else
		{
			setAnchorElPop(event.currentTarget);
		}
	};

	const handleButtonClick = (event) =>
	{
		if (clickCount === 0)
		{
			setAnchorElPop(true); // Open the popup on the first click
			setClickCount(1); // Increment the counter
			setAnchorElPop(event.currentTarget);
		}
		else
		{
			setShowReminder(true); // Open the slider on the second click
		}
	};

	const handleClosePop = () =>
	{
		setAnchorElPop(false);
	};

	const handleShowReminder = () =>
	{
		setShowReminder(true);
	};

	const handleReminderClose = () =>
	{
		setShowReminder(false);
		setClickCount(0);
	};

	const theme = useTheme();
	const downSM = useMediaQuery(theme.breakpoints.down(600));
	const handleOpenNotification = () =>
	{
		props?.setNotificationSlider(!props?.notificationSlider);
		props?.setNotifyView({ state: false, data: null });
		setOpenSlider(false);
	};
	const handleInvite = () =>
	{
		handleClose();
		setOpenSlider(true);
		props?.setNotificationSlider(false);
	};

	// effect to get notification count
	useLayoutEffect(() =>
	{
		if (socket)
		{
			const handleNotificationTrigger = () =>
			{
				// get notification count
				dispatch(getNotification(nc + 1));
			};

			// used to trigger notification count
			socket.on('triggerNotificationCount', handleNotificationTrigger);

			return () =>
			{
				// remove event listener
				socket.off('triggerNotificationCount', handleNotificationTrigger);
			};
		}
	}, [ socket, nc, dispatch ]);

	// effect to fetch initial notification count
	useEffect(() =>
	{
		const fetchInitialNotificationCount = async () =>
		{
			try
			{
				const response = await getNotifications('?status=all&count=true');

				if (response?.data?.unreadCount !== undefined)
				{
					dispatch(getNotification(response.data.unreadCount));
				}
			}
			catch (error)
			{
				console.log('Error fetching initial notification count:', error);
			}
		};

		// Only fetch if we don't already have a count, user is logged in, and employee is active
		if (userData?.userId && nc === 0 && userData?.isActive === 'active')
		{
			fetchInitialNotificationCount();
		}
	}, [ userData?.userId, dispatch ]);

	// useEffect(() =>
	// {
	// 	// setProfileLoader(true);
	// 	setTimeout(() =>
	// 	{
	// 		setImgPath(`${userData?.userId}.jpeg?t=${new Date().toLocaleTimeString()
	// 			.replaceAll('_', '_')}`);
	// 	}, 5000);
	// }, [ userData?.profileImage, userData?.profileKey ]);

	useEffect(() =>
	{
		document.body.style.overflow = overflowStyle;
	}, [ hamBurgerShow ]);

	const handleHam = () =>
	{
		setHamBurgerShow(!hamBurgerShow);
	};

	const langhandleClose = () => { setLangOpen(false); };
	const handleChange = (id:any) =>
	{
		localStorage.setItem('customer_language', id);
		langhandleClose();
	};

	const handleClick = (event) =>
	{
		setAnchorEl(event.currentTarget);
	};

	const handleLogoutPopup = () =>
	{
		setLogout(true);
		setAnchorEl(null);
	};

	const handleClickLogout = async () =>
	{
		if (!loading)
		{
			setLoading(true);
			try
			{
				// Emit socket event if logout from all devices is selected

				if (logoutFromAllDevices && socket)
				{
					// Call logout API first
					await logoutUser(logoutFromAllDevices);

					socket.emit('on_updates', {
						type     : 'log_out_from_all_devices',
						// userId   : userData?.userId,
						masterId : userData?.masterId
					});
				}

				// Then proceed with existing logout flow
				await handleLogout();
			}
			catch (error)
			{
				console.log('handlelogout***error', error);
				setLogout(false);
				setLoading(false);
			}
		}
		// if (userData?.presenceEnabled)
		// {
		// 	try
		// 	{
		// 		const token = sessionStorage.getItem('fcmToken');

		// 		if (token)
		// 		{
		// 			await manageNotifications({ userId: userData?.userId, token, subscribe: false, scenario: 'login' });
		// 		}
		// 		// const deviceData = JSON.parse(sessionStorage.getItem('deviceData'))
		// 		// await removeUserOnlineStatus(userInfo?.userId, deviceData?.deviceId);

		// 		//    await updateDeviceData?.removeConnection();

		// 		// to update that the user is in OFFLINE
		// 		const userRes = await getDocByDocumentId('users', userData?.userId);

		// 		if (userRes?.exists())
		// 		{
		// 			let existingTokens = [];

		// 			if (userRes.data()?.inLynkTokens?.webTokens)
		// 			{
		// 				existingTokens = userRes.data()?.inLynkTokens?.webTokens?.filter((prevToken) => prevToken !== token);
		// 			}

		// 			await updateDocByDocumentId('users', userData?.userId, { isOnline: false, updatedAt: new Date().valueOf(), 'inLynkTokens.webTokens': existingTokens });
		// 			await deleteToken(firebaseMessaging);
		// 			const auth = getAuth();

		// 			await signOut(auth);
		// 		}
		// 		// stopVideoStream();
		// 	}
		// 	catch (err)
		// 	{
		// 		console.log(err, 'error========');
		// 	}
		// }
	};

	const handleNavigate = useCallback((linkPath: any) =>
	{
		navigate(linkPath);
		setShowSideNavIcons(false);
	}, []);

	const handlePrfSettings = () =>
	{
		setProfileSettings(true);
		setHamBurgerShow(false);
		setShowSideNavIcons(false);
	};

	useEffect(() =>
	{
		const handleResize = () =>
		{
			setCheckScreenSize(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		// Cleanup function to remove the event listener when the component unmounts
		return () =>
		{
			window.removeEventListener('resize', handleResize);
		};
	}, [ window.innerWidth ]);

	const handleHamBug = () =>
	{
		const checkToOpen = ([ '/profileSettings', '/certificationExam', '/examStatus', '/createNewTemplate' ]?.includes(`/${activePath}`) || (userData?.empRole !== 'employee' && [ '/businessSettings' ]?.includes(`/${activePath}`)));

		(checkToOpen || checkScreenSize <= 1199) ? setHamBurgerShow(!hamBurgerShow) : navigate('/news');
	};

	const handleToggle = useCallback(() =>
	{
		if (document && !document.fullscreenElement)
		{
			document.documentElement.requestFullscreen();
		}
		else if (document.exitFullscreen)
		{
			document.exitFullscreen();
		}
	}, []);

	// Listen for fullscreen changes (including ESC key)
	useEffect(() =>
	{
		const handleFullscreenChange = () =>
		{
			setMaximizeScreen(Boolean(document.fullscreenElement));
		};

		document.addEventListener('fullscreenchange', handleFullscreenChange);

		return () =>
		{
			document.removeEventListener('fullscreenchange', handleFullscreenChange);
		};
	}, []);

	const handleHelpSupport = () =>
	{
		handleClose();
		navigate('/helpandsupport');
	};
	const checkToOpen = ([ '/profileSettings', '/certificationExam', '/examStatus', '/createNewTemplate' ]?.includes(`/${activePath}`) || (userData?.empRole !== 'employee' && [ '/businessSettings' ]?.includes(`/${activePath}`)));
	const handleMenuClick = () =>
	{
		setShowSideNavIcons(!showSideNavIcons);
	};

	const isActive = location.pathname === '/helpandsupport';

	const { addChatBox } = useChat();

	return (
		<>
			{loading && <Loading/>}
			<div className={`flexRow ${([ '/profileSettings', '/certificationExam', '/examStatus', '/createNewTemplate' ]?.includes(`/${activePath}`) || (userData?.empRole !== 'employee' && [ '/businessSettings' ]?.includes(`/${activePath}`))) ? 'headerContact' : `${showSideNavIcons ? 'mobHeader' : 'header'}`} brdrBSM alignCntr respdngHSM  whiteBg`}>
				{/* <div className={`flexRow ${(contactHamBurger || [ '/contacts', '/businessSettings', '/profileSettings', '/certificationExam', '/examStatus', '/createNewTemplate' ]?.includes(`/${activePath}`)) ? 'headerContact' : 'header'} brdrBSM alignCntr respdngHSM  whiteBg`}> */}

				{/* <InLinkLogo handleCloseRespSideNav={props?.handleCloseRespSideNav} /> */}
				{/* {([ '/businessSettings', '/profileSettings' ]?.includes(`/${activePath}`) || checkScreenSize <= 1199) && !showSideNavIcons && */}
				{!checkToOpen && <div className='flexAutoRow pointer alignCntr jusifyCntr pdngHXS MobdisplaRnot' onClick={handleMenuClick}>
					{showSideNavIcons
						? <RiMenuUnfoldFill fontSize='var(--pixel20)' />
						: <RiMenuFoldFill fontSize='var(--pixel20)' />}

				</div>}
				{/* {!checkToOpen && <InLinkLogo handleCloseRespSideNav={props?.handleCloseRespSideNav} />} */}
				{([ '/profileSettings' ]?.includes(`/${activePath}`) || (userData?.empRole !== 'employee' && [ '/businessSettings' ]?.includes(`/${activePath}`)) || checkScreenSize <= 1199) && !showSideNavIcons &&
					<div className='flexAutoRow alignCntr pdngHXS'>
						<GiHamburgerMenu fontSize='var(--pixel24)' onClick={handleHamBug} cursor={'pointer'}/>
					</div> }
				<InLinkLogo handleCloseRespSideNav={props?.handleCloseRespSideNav} />
				{/* } */}

				<div className='flexMinWidthRow justifyEnd alignCntr'>
					<Modal
						open={langOpen}
						onClose={langhandleClose}
						aria-labelledby='modal-modal-title'
						aria-describedby='modal-modal-description'
					>
						<Box sx={style}>
							<div className='flexRow alignCntr pdngXS'>
								<div className='flexMinWidthRow pdngHXS'><Typography variant='h5' component='h5'>
									{language?.selectLanguage}
								</Typography></div>
								<div className='flexAuto'><IconButton onClick={langhandleClose}><Close /></IconButton></div>
							</div>
							<ul className=''>
								{Data.map((each, index) =>
								{
									const lastBtn = index === (Data.length - 1) ? 'lastBtn' : '';

									return (
										<button className={`flexRow alignCntr justifyBtwn LangBtn respdngHMD ${lastBtn}`} onClick={() => { handleChange(each.id); }} key={each.id}>
											<span>{each.label}</span>
										</button>
									);
								})}
							</ul>
						</Box>
					</Modal>
					<Stack direction={'row'} spacing={1} alignItems={'center'}>
						{!downSM && <Box>
							<Tooltip title='Invite' placement='bottom'>
								<IconButton
									size='medium'
									onClick={handleInvite}
									sx={{
										transition      : 'transform 0.2s, color 0.2s',
										padding         : '6px',
										color           : openSlider ? '#23A4C4' : '',
										transform       : openSlider ? 'scale(1.2)' : '',
										backgroundColor : 'transparent',
										'&:hover'       : {
											color           : '#23A4C4', // Hover color,
											backgroundColor : 'transparent',

											transform : 'scale(1.2)' // Hover scale
										}
									}}
								>
									<FiSend fontSize='var(--pixel20)' />
								</IconButton>

							</Tooltip>
						</Box>}
						{/* } */}
						{/* <div className='flexAutoRow pointer pdngLSM imgAvatarSM' onClick={handleHelpSupport}> */}
						{/* <div className='flexAutoRow pointer' > */}
						{!downSM && <Box>
							<Tooltip title='Help & Support' placement='bottom'>
								<IconButton size='small' sx={{
									padding         : 0,
									backgroundColor : 'transparent',
									filter          : isActive ? 'invert(49%) sepia(98%) saturate(365%) hue-rotate(145deg) brightness(93%) contrast(92%)' : 'none',
									transform       : isActive ? 'scale(1.2)' : 'none',
									transition      : 'transform 0.2s, color 0.2s',
									'&:hover'       : {
										backgroundColor : 'transparent',
										filter          : 'invert(49%) sepia(98%) saturate(365%) hue-rotate(145deg) brightness(93%) contrast(92%)',
										transform       : 'scale(1.2)'
									}
								}} onClick={handleHelpSupport}
								>
									<Box component={'img'} sx={{ width: 'var(--pixel20)', height: 'var(--pixel20)', margin: 'var(--pixel8)' }} src='/images/icons/Help&Support.svg' alt=''/>
								</IconButton>
							</Tooltip>
						</Box>}
						{/* </div> */}
						{/* {!downSM && */}
						<Box>
							<Tooltip title={`${!maximizeScreen ? 'Maximize' : 'Minimize'}`}>
								<IconButton size='medium' onClick={handleToggle} sx={{ padding         : 'var(--pixel4)',
									backgroundColor : 'transparent',
									transition      : 'transform 0.2s, color 0.2s',
									color           : maximizeScreen ? '#23A4C4' : '',
									transform       : maximizeScreen ? 'scale(1.2)' : 'none',
									'&:hover'       : {
										backgroundColor : 'transparent',

										color     : '#23A4C4', // Hover color
										transform : 'scale(1.2)' // Hover scale
									} }}
								>
									{!maximizeScreen
										? <MdFullscreen fontSize='var(--pixel24)' />
										: <FiMinimize fontSize='var(--pixel24)' />}
								</IconButton>
							</Tooltip>
						</Box>
						{/* } */}
						{/* Reminder functionality not completed that's why currently keeping in comment mode... */}
						{/* <Tooltip title={language?.reminder} placement='bottom'>
							<div className='flexAutoRow pointer pdngRXXS' onClick={handleButtonClick}>
								<IconButton>
									<Badge badgeContent={String(nc)} color='default' classes={{ badge: 'notificationBg' }} className='whiteTxt'>
										<FiClock fontSize={22} color='#6B7280' />
									</Badge>
								</IconButton>
							</div>
						</Tooltip> */}
						<Box>
							<Tooltip title={language?.notifications}>
								<IconButton sx={{ padding         : 'var(--pixel4)',
									backgroundColor : 'transparent',
									fontSize        : 24,
									transition      : 'transform 0.2s, color 0.2s',
									color           : props?.notificationSlider ? '#23A4C4' : '',
									transform       : props?.notificationSlider ? 'scale(1.2)' : 'none',
									'&:hover'       : {
										backgroundColor : 'transparent',

										color     : '#23A4C4', // Hover color
										transform : 'scale(1.2)' // Hover scale
									} }} tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleOpenNotification(); }} onClick={handleOpenNotification}
								>

									{nc > 0
										? <Badge badgeContent={String(nc)} color='default' classes={{ badge: 'notificationBg' }} className='whiteTxt'>
											<NotificationsOutlinedIcon sx={{ color: props?.notificationSlider ? '#23A4C4' : '#757575', '&:hover': { color: '#23A4C4' } }} />
										</Badge>
										: <NotificationsOutlinedIcon />
									}

								</IconButton>
							</Tooltip>
						</Box>
						<div className='flexAutoRow  pdngHSM' >
							<button className='flexAutoRow pointer' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleClick(e); }} onClick={handleClick}>
								{userData?.profileImage && !imageError
									? <div className='imgAvatarSM brdrBlackSM brdrRadius50'>
										<LazyLoadImage
											src={imagePath}
											alt='img' className='brdrRadius50 pointer'
											delayTime={process.env.REACT_APP_PROFILE_DELAY_TIME} effect={process.env.REACT_APP_EFFECT}
											width={`${process.env.REACT_APP_IMG_WIDTH}%`} height={`${process.env.REACT_APP_IMG_HEIGHT}%`}
											onError={(e) => { setImageError(true); }}
										/>
									</div>
									: <div className='circle circleSM brdrBlackSM'>
										<span className='capitalTxt'>{userData?.name?.charAt(0) || ''}</span>
									</div>
								}
							</button>
						</div>
					</Stack>
				</div>
				<Menu
					id='basic-menu'
					className=''
					anchorEl={anchorEl}
					open={open}
					onClose={handleClose}
					PaperProps={{
						elevation : 0,
						sx        : {
							overflow            : 'visible',
							filter              : 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
							mt                  : 1.5,
							'& .MuiAvatar-root' : {
								width  : 32,
								height : 32,
								ml     : -0.5,
								mr     : 1
							},
							'&:before' : {
								content   : '""',
								display   : 'block',
								position  : 'absolute',
								top       : 0,
								right     : 14,
								width     : 10,
								height    : 10,
								bgcolor   : 'background.paper',
								transform : 'translateY(-50%) rotate(45deg)',
								zIndex    : 0
							}
						}
					}}
					transformOrigin={{ horizontal: 'right', vertical: 'top' }}
					anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
				>
					{/* <MenuItem selected={window?.location?.pathname?.includes('profileSettings')}>
						<div className='flexRow alignCntr' onClick={() => handleNavigate('/profileSettings/profile')}>
							<div className='flexAutoRow lightTxt'>
								<IoSettingsOutline/>
							</div>
							<div className='flexMinWidthRow' onClick={handlePrfSettings}>
								<span>Settings</span>
							</div>
						</div>
					</MenuItem>
					{downSM && <MenuItem >
						<div className='flexRow alignCntr' onClick={handleInvite}>
							<div className='flexAutoRow lightTxt'>
								<FiSend />
							</div>
							<div className='flexMinWidthRow'>
								<span>{language?.invite}</span>
							</div>
						</div>
					</MenuItem>}
					{downSM && <MenuItem >
						<div className='flexRow alignCntr' onClick={handleHelpSupport}>
							<div className='flexAutoRow invertGray imgAvatarXXXS pdngRXXS'>
								<img src='/images/icons/Help&Support.svg' alt=''/>
							</div>
							<div className='flexMinWidthRow'>
								<span>Help&Support</span>
							</div>
						</div>
					</MenuItem>}
					<MenuItem>
						<div className='flexRow alignCntr' onClick={handleLogoutPopup}>
							<div className='flexAutoRow lightTxt'>
								<IoLogOutOutline/>
							</div>
							<div className='flexMinWidthRow'>
								<span>Log Out</span>
							</div>
						</div>
					</MenuItem> */}
					<Grid container direction='column' p={2} minWidth={downSM ? 290 : 320}>
						<Grid container direction={'row'} width='100%'>
							<Grid item className='imgAvatarSLG'>
								{/* <ProfilePic
									imagePath={`${userData?.userId}_profile.jpeg?t=${new Date().valueOf()}`}
									defaultImg={userData?.role === 'company' ? '/images/logos/no_logo.png' : '/images/icons/defaultUser.svg'}
									alt='createdBy'
									className='brdrRadius50  pointer'
								/> */}
								<LazyLoadImage
									src={imagePath}
									alt='img' className='brdrRadius50 pointer'
									delayTime={process.env.REACT_APP_PROFILE_DELAY_TIME} effect={process.env.REACT_APP_EFFECT}
									width={`${process.env.REACT_APP_IMG_WIDTH}%`} height={`${process.env.REACT_APP_IMG_HEIGHT}%`}
									onError={(e) => { e.target.src = '/images/icons/defaultUser.svg'; }}
								/>
							</Grid>
							<Grid item xs minWidth={0} pl={2}>
								<Typography
									variant='h6'
									sx={{
										whiteSpace    : 'nowrap',
										overflow      : 'hidden',
										textOverflow  : 'ellipsis',
										width         : '100%',
										textTransform : 'capitalize'
									}}
								>
									{userData?.name || (userData?.firstName && userFullName(userData)) || language?.nA}
								</Typography>
								<Typography
									variant='body2'
									color='text.secondary'
									sx={{
										whiteSpace    : 'nowrap',
										overflow      : 'hidden',
										textOverflow  : 'ellipsis',
										width         : '100%',
										textTransform : 'capitalize'

									}}
								>	{userData?.empRole && userData?.empRole === 'superAdmin'
										? language?.superAdmin
										: userData?.empRole || userData?.role}
								</Typography>
								<Typography
									variant='body2'
									color='text.secondary'
									className='flexRow'
									sx={{
										whiteSpace   : 'nowrap',
										overflow     : 'hidden',
										textOverflow : 'ellipsis',
										width        : '100%'
									}}
								>
									{userData?.email || userData?.SAMail || language?.nA}
								</Typography>
							</Grid>
						</Grid>
						<Stack direction={'row'} pt={1.5} justifyContent={'space-between'} width={'100%'} alignItems={'center'} spacing={2}>
							<Box display={'flex'} sx={{ cursor: 'pointer' }}
								onClick={() => { handleClose(); handleNavigate('/profileSettings/profile'); }}
								borderRadius={'4px'} width='50%' justifyContent='center' flexDirection={'row'} bgcolor={'#57575712'} alignItems={'center'} p={1}
							>
								<CgProfile />
								<Typography pl={0.5}>{language?.settings}</Typography>
							</Box>
							<Box display={'flex'} sx={{ cursor: 'pointer' }} onClick={handleLogoutPopup} borderRadius={'4px'} width='50%' justifyContent='center' flexDirection={'row'} bgcolor={'#57575712'} alignItems={'center'} p={1}>
								<TbLogout color='#F06A73'/>
								<Typography pl={0.5} color={'#F06A73'}>{language?.signout}</Typography>
							</Box>
						</Stack>
						{downSM &&
						<Stack direction={'row'} pt={1.5} justifyContent={'space-between'} width={'100%'} alignItems={'center'} spacing={1}>
							<Box display={'flex'} sx={{ cursor: 'pointer' }} onClick={handleInvite} borderRadius={'4px'} width='50%' justifyContent='center' flexDirection={'row'} bgcolor={'#57575712'} alignItems={'center'} p={1}>
								<FiSend />
								<Typography variant='body2' pl={0.5}>{language?.invite}</Typography>
							</Box>
							<Box display={'flex'} sx={{ cursor: 'pointer' }} onClick={handleHelpSupport} borderRadius={'4px'} width='50%' justifyContent='center' flexDirection={'row'} bgcolor={'#57575712'} alignItems={'center'} p={1}>
								<Box width={'18px'} height={'18px'}>
									<img src='/images/icons/Help&Support.svg' alt=''/>
								</Box>
								<Typography variant='body2' pl={0.5}>{language?.helpSupp}</Typography>
							</Box>
						</Stack>}
					</Grid>

				</Menu>
				{logout && (
					<Dialog
						open={logout}
						onClose={() => { setLogout(false); setAnchorEl(null); setLogoutFromAllDevices(false); }}
						aria-labelledby='logout-dialog-title'
						aria-describedby='logout-dialog-description'
						fullWidth
						maxWidth='sm'
					>
						<DialogTitle id='logout-dialog-title'>
							{language?.confirmation}
						</DialogTitle>
						<DialogContent>
							<Typography variant='body1' gutterBottom>
								{language?.logoutTxt}
							</Typography>
							<Box mt={2}>
								<FormControlLabel
									control={
										<Checkbox
											checked={logoutFromAllDevices}
											onChange={(e) => setLogoutFromAllDevices(e.target.checked)}
											color='primary'
										/>
									}
									label={language?.logoutFromAllDevices || 'Logout from all devices'}
								/>
							</Box>
						</DialogContent>
						<DialogActions>
							<Box className='flexRow justifyEnd pdngXS'>
								<span className='pdngRSM'>
									<Button
										disableElevation
										disableFocusRipple
										disableRipple
										disableTouchRipple
										onClick={() => { setLogout(false); setAnchorEl(null); setLogoutFromAllDevices(false); }}
									>
										{language?.cancel}
									</Button>
								</span>
								<Button
									disableElevation
									disableFocusRipple
									disableRipple
									disableTouchRipple
									onClick={handleClickLogout}
									variant='contained'
									className='whiteTxt'
									// disabling logout for couple of seconds when user logs in to prevent race condition to login the user back
									disabled={Object.keys(userData ?? {}).length <= 15}
								>
									{language?.logout}
								</Button>
							</Box>
						</DialogActions>
					</Dialog>
				)}
				<button className={(hamBurgerShow) ? 'sidenavOverlaySlider fadeInOverlay' : 'sidenavOverlaySlider'} onKeyUp={(e) => { e.key === 'Enter' && handleHam(); }} onClick={handleHam}/>
				<div className={(hamBurgerShow || showSideNavIcons) ? `${!showSideNavIcons ? ([ '/businessSettings', '/profileSettings' ]?.includes(`/${activePath}`) && userData?.empRole !== 'employee') ? 'resSideNav' : 'resSideNav' : window?.location?.pathname?.includes('examStatus') ? 'displayNone' : 'resMobSideNav'} flexCol sideNavSlideIn` : 'flexCol resSideNav peopleSideNav'}>
					{/* {(hamBurgerShow) && <CompanySideNav />} */}
					{(hamBurgerShow || showSideNavIcons) && <BusinessSideNav />}
				</div>
			</div>
			{profileSettings && <ProfileSettingsNav />}
			{openSlider && 	<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && setOpenSlider(!openSlider); }} 	className={openSlider ? 'overlaySlider fadeInOverlay' : ''}	onClick={() => { setOpenSlider(!openSlider); }}/>}
			<div
				className={
					openSlider
						? 'flexCol fxdSocialMediaSlider slideIn'
						: 'flexCol fxdSocialMediaSlider '
				}
			>
				{openSlider && <EmployeeListSlider handleClose={() => setOpenSlider(false)} /> }
			</div>
			<div>{showReminder && <ReminderSlider open={showReminder} onClose={handleReminderClose} />}</div>
			<RemindPopover anchorEl={anchorElPop} onClose={handleClosePop} />
		</>
	);
};

export default memo(CommonHeader);